import { Swiper, SwiperSlide, Navigation, Pagination, Grid, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/grid";

const breakpoint = window.matchMedia("(min-width:1024px)");
export const AllSwipers = new Map();

class BTSwiper {
	constructor(domNode, options = { type: "default", config: {} }) {
		this.rootEl = domNode;
		this.slides = Array.from(this.rootEl.children[0].children);
		this.columns = parseInt(this.rootEl.dataset.swiperCols) || 4;
		this.rows = parseInt(this.rootEl.dataset.swiperRows) || false;
		this.options = options;
		this.swiper = this.initSwiper();
		this.addEventListeners();

		console.log(this);

		// Add to the map so we can see all of the swipers
		AllSwipers.set(this.rootEl, this);
	}

	initSwiper() {
		let slideWidth = 289;

		let grid = {};
		let autoplay = {};
		let spaceBetween = (1300 - slideWidth * this.columns) / (this.columns - 1);

		if (this.columns > 4) {
			spaceBetween = 32;
		}

		let breakpoints = {
			breakpoints: {
				290: {
					slidesPerView: "auto",
				},
				// when window width is >= 320px
				320: {
					slidesPerView: "auto",
				},
				610: {
					slidesPerView: 2,
					spaceBetween: (610 - slideWidth * 2) / 1,
				},
				738: {
					slidesPerView: 2,
					spaceBetween: (738 - slideWidth * 2) / 1,
				},
				994: {
					slidesPerView: 3,
					spaceBetween: (994 - slideWidth * 3) / 2,
				},
				1300: {
					slidesPerView: this.columns,
					spaceBetween: spaceBetween,
				},
			},
		};

		if (this.options.type === "accreditations") {
			breakpoints = {
				breakpoints: {
					290: {
						slidesPerView: 3,
						spaceBetween: spaceBetween,
					},
					// when window width is >= 320px
					320: {
						slidesPerView: 3,
						spaceBetween: spaceBetween,
					},
					610: {
						slidesPerView: 4,
						spaceBetween: spaceBetween,
					},
					1300: {
						slidesPerView: this.columns,
						spaceBetween: spaceBetween,
					},
				},
			};
		}

		if (this.columns === 1) {
			breakpoints = {
				breakpoints: {
					290: {
						slidesPerView: 1,
					},
				},
			};
		}

		if (this.columns === 3) {
			slideWidth = 422;

			breakpoints = {
				breakpoints: {
					290: {
						slidesPerView: "auto",
					},
					// when window width is >= 320px
					320: {
						slidesPerView: "auto",
					},
					610: {
						slidesPerView: "auto",
					},
					994: {
						slidesPerView: this.columns - 1,
						spaceBetween: (994 - slideWidth * (this.columns - 1)) / (this.columns - 1),
					},
					1300: {
						slidesPerView: this.columns,
						spaceBetween: (1300 - slideWidth * this.columns) / (this.columns - 1),
					},
				},
			};
		}

		if (this.rows) {
			breakpoints = {};

			grid = {
				slidesPerView: 1,
				spaceBetween: 26,
				grid: {
					fill: "column",
					fill: "row",
					rows: this.rows,
				},
			};
		}

		const config = {
			// configure Swiper to use modules
			modules: [Navigation, Pagination, Grid, Autoplay],
			// spaceBetween: 0,
			grid: {
				rows: 1,
			},
			...breakpoints,
			...grid,
			autoplay: autoplay,
			breakpointsBase: "container",
			pagination: {
				el: ".swiper-pagination",
				type: "bullets",
				clickable: true,
			},
			...(this.options?.config ?? {}),
		};

		if (this.options.type !== "mobile-only") {
			this.slides.forEach((slide) => {
				slide.classList.add("swiper-slide");

				/**
				 * This is needed to fix the responsive styling of the
				 * slides when they have been given a max-width of 289px
				 *
				 * In this case, this is the staff cards
				 *
				 * TODO: Make this more generic so it can be used for other
				 * sizes however by doing this we will lose the ability
				 * to use tailwind classes
				 */
				if (slide.classList.contains("sm:max-w-[289px]")) {
					slide.classList.add("[@media(max-width:639px)]:!mr-[calc(100%_-_289px_+_31px_+_17px)]");
					slide.classList.add("[@media(min-width:310px)]:max-w-[289px]");
					slide.classList.add("w-fit");
				}
			});
		}

		if (this.options.type === "mobile-only") {
			this.toggleSwiperClasses(this.rootEl, "off");
		}

		return new Swiper(this.rootEl, config);
	}

	addEventListeners() {
		if (this.options.type === "mobile-only") {
			breakpoint.addEventListener("change", (event) => {
				this.breakpointChecker();
			});
		}
	}

	enableSwiper() {
		this.toggleSwiperClasses(this.rootEl, "on");

		this.initSwiper();
	}

	breakpointChecker() {
		if (breakpoint.matches) {
			// Remove the slider and cleanup classes
			if (allSwipers !== undefined) {
				// We need to check if there are multiple swipers or just one
				if (typeof allSwipers.forEach !== "undefined") {
					allSwipers.forEach((swiper) => {
						// Classes need to be toggled before the slider is destroyed
						// otherwise it will trigger a bug
						toggleSwiperClasses(swiper.wrapperEl.parentElement, "off");
						swiper.destroy(true, true);
					});
				} else {
					toggleSwiperClasses(allSwipers.wrapperEl.parentElement, "off");
					allSwipers.destroy(true, true);
				}
			} else {
				// This is needed for when the slider isn't init already but
				// we still need to clean up the classes
				document.querySelectorAll(".swiper-mobile").forEach((swiper) => {
					toggleSwiperClasses(swiper, "off");
				});
			}
			return;
		} else if (breakpoint.matches === false) {
			// Enable the swiper on the mobile viewports
			return enableSwiper({ target: ".swiper-mobile" });
		}
	}

	toggleSwiperClasses(target, mode = "on") {
		if (mode === "on") {
			target.children[0].classList.remove("grid-cols-3");
			target.children[0].classList.add("swiper-wrapper");
			var slides = target.children[0].children;
			for (var i = 0; i < slides.length; i++) {
				slides[i].classList.add("swiper-slide");
			}
			// target.children[0].classList.add("!gap-0");
			if (target.querySelector(".swiper-pagination")) {
				target.querySelector(".swiper-pagination").classList.remove("hidden");
			}
		}

		if (mode === "off") {
			target.children[0].classList.add("grid-cols-3");
			target.children[0].classList.remove("swiper-wrapper");
			var slides = target.children[0].children;
			for (var i = 0; i < slides.length; i++) {
				slides[i].classList.remove("swiper-slide");
			}
			// target.children[0].classList.remove("!gap-0");
			if (target.querySelector(".swiper-pagination")) {
				target.querySelector(".swiper-pagination").classList.add("hidden");
			}
		}
	}
}

// Init swipers
const swiperTargets = document.querySelectorAll(".swiper");
const mobileSwiperTargets = document.querySelectorAll(".swiper-mobile");

swiperTargets.forEach((targetEl) => {
	let config = { type: "default" };

	if (targetEl.classList.contains("swiper-accreditations")) {
		config = {
			type: "accreditations",
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
		};
	}

	new BTSwiper(targetEl, config);
});

mobileSwiperTargets.forEach((targetEl) => {
	new BTSwiper(targetEl, { type: "mobile-only" });
});
